export default function () {
  this.loadTerms()
}
